import { jsx } from 'react/jsx-runtime';

/** ![heading4Icon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNCAxMmg4TTQgMThWNk0xMiAxOFY2TTE3IDEwdjRoNE0yMSAxMHY4Ii8+PC9zdmc+) */
const heading4Icon = /*#__PURE__*/jsx("path", {
  d: "M4 12h8M4 18V6M12 18V6M17 10v4h4M21 10v8"
});

export { heading4Icon };
